import * as fromReducer from './mdm-installed-applications.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { InstalledApplication, InstalledApplicationsState } from './mdm-installed-applications.state';
import { DevicesRouterStoreSelectors } from '../router';

export const selectMdmInstalledApplicationsState = createFeatureSelector<InstalledApplicationsState>(
  fromReducer.mdmInstalledApplicationsFeatureKey
);

export const selectMdmInstalledApplications = createSelector(
  selectMdmInstalledApplicationsState,
  fromReducer.selectAllMdmInstalledApplications
);

export const selectMdmInstalledApplicationsEntities = createSelector(
  selectMdmInstalledApplicationsState,
  fromReducer.selectMdmInstalledApplicationsEntities
);

export const selectMdmInstalledApplicationsIds = createSelector(
  selectMdmInstalledApplicationsState,
  fromReducer.selectMdmInstalledApplicationsIds
);

export const selectMdmInstalledApplicationsByUdid = createSelector(
  selectMdmInstalledApplications,
  DevicesRouterStoreSelectors.selectUdid,
  (applications: InstalledApplication[], udid: string) => applications.filter((app) => app.udid === udid)
);

export const selectMdmInstalledApplicationsByUdidAndBundleId = (bundleId: string) =>
  createSelector(selectMdmInstalledApplicationsByUdid, (applications: InstalledApplication[]) =>
    applications.find((app) => app.identifier === bundleId)
  );
